import { render } from "./KanbanBoardView.vue?vue&type=template&id=e69aaed2&scoped=true"
import script from "./KanbanBoardView.vue?vue&type=script&lang=js"
export * from "./KanbanBoardView.vue?vue&type=script&lang=js"

import "./KanbanBoardView.vue?vue&type=style&index=0&id=e69aaed2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e69aaed2"]])

export default __exports__